import { UserType } from "interfaces";

const LOCAL_HOSTNAMES = ["localhost", "127.0.0.1", "0.0.0.0"];
const LOCAL_WORKSPACE_DOMAIN = "https://vietnam-mtb-series.uat-workspace.actiup.net";

const getStoredUserType = () => {
  const user = localStorage.getItem("USER");

  if (!user) {
    return null;
  }

  try {
    return JSON.parse(user)?.type;
  } catch {
    return null;
  }
};

export const getWorkspaceAuthDomain = () => {
  if (LOCAL_HOSTNAMES.includes(window.location.hostname)) {
    return LOCAL_WORKSPACE_DOMAIN;
  }

  return window.location.origin;
};

export const getChangePasswordOriginUrl = () => {
  if (getStoredUserType() === UserType.WPS) {
    return getWorkspaceAuthDomain();
  }

  return window.location.origin;
};
